import Vue from 'vue';
import Router from 'vue-router';
import AdminLogin from './views/admin/login.vue';
import AdminSchoolManage from './views/admin/schoolManage.vue';
import AdminUserList from './views/admin/userList.vue';
import AdminOwnerList from './views/admin/ownerList.vue';
import AdminNewsList from './views/admin/newsList.vue';
import AdminNewsEdit from './views/admin/newsEdit.vue';
import AdminMyPage from './views/admin/myPage.vue';
import AdminError from './views/admin/error.vue';
import Login from './views/login.vue';
import Top from './views/top.vue';
import MyPage from './views/myPage.vue';
import MessageList from './views/message/messageList.vue';
import MessageDetails from './views/message/messageDetails.vue';
import MessageEdit from './views/message/messageEdit.vue';
import CommentView from './views/message/commentView.vue';
import ChatList from './views/chat/chatList.vue';
import ChatMessageView from './views/chat/chatMessageView.vue';
import ReportList from './views/report/reportList.vue';
import ReportDetails from './views/report/reportDetails.vue';
import ReportEdit from './views/report/reportEdit.vue';
import RecordList from './views/record/recordList.vue';
import RecordView from './views/record/recordView.vue';
import EnterLeaveList from './views/enterLeave/enterLeaveList.vue';
import SchoolEdit from './views/school/schoolEdit.vue';
import GradeAdvanceSetting from './views/school/gradeAdvanceSetting.vue';
import UserList from './views/user/userList.vue';
import StudentList from './views/student/studentList.vue';
import StudentDetails from './views/student/studentDetails.vue';
import StudentEdit from './views/student/studentEdit.vue';
import StudentBulkCreate from './views/student/studentBulkCreate.vue';
import RecordControlList from './views/recordControl/recordControlList.vue';
import RecordControlEdit from './views/recordControl/recordControlEdit.vue';
import Error from './views/error.vue';
import SingleSignOn from './views/singleSignOn.vue';
import ManualList from './views/manual/manualList.vue';
import Schedule from './views/schedule/index.vue';
import ReservableCount from './views/schedule/reservableCount.vue';
import BaseSchedule from './views/schedule/baseSchedule.vue';
import ScheduleEdit from './views/schedule/edit.vue';
import Reservation from './views/reservation/index.vue';
import ReservationCalendar from './views/reservation/calendar/index.vue';
import StudentCalendar from './views/student/studentCalendar.vue';
import StudentCreditcard from './views/student/studentCreditcard.vue';
import TagList from './views/tags/index.vue';
import BillList from './views/bill/bills/index.vue';
import BillDownload from './views/bill/bills/download.vue';
import BillDetail from './views/bill/bills/_billId/index.vue';
import BillEdit from './views/bill/bills/_billId/edit.vue';
import PeriodicBillList from './views/bill/periodic-bills/index.vue';
import PeriodicBillDetail from './views/bill/periodic-bills/_periodicBillId/index.vue';
import PeriodicBillEdit from './views/bill/periodic-bills/_periodicBillId/edit.vue';
import BillTemplateList from './views/bill/bill-templates/index.vue';
import BillTemplateEdit from './views/bill/bill-templates/_billTemplateId/edit.vue';
import BillSetting from './views/bill/settings/bill.vue';
import CreditcardSetting from './views/bill/settings/creditcard.vue';
import BillItemsSetting from './views/bill/settings/bill-items.vue';
import Checkout from './views/checkout.vue';

Vue.use(Router);

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/admin',
      name: 'AdminTop',
      component: AdminSchoolManage,
      meta: { requiresAuth: true }
    },
    {
      path: '/admin/login',
      name: 'AdminLogin',
      component: AdminLogin
    },
    {
      path: '/admin/myPage',
      name: 'AdminMyPage',
      component: AdminMyPage,
      meta: { requiresAuth: true }
    },
    {
      path: '/admin/userList',
      name: 'AdminUserList',
      component: AdminUserList,
      meta: { requiresAuth: true }
    },
    {
      path: '/admin/ownerList',
      name: 'AdminOwnerList',
      component: AdminOwnerList,
      meta: { requiresAuth: true }
    },
    {
      path: '/admin/newsList',
      name: 'AdminNewsList',
      component: AdminNewsList,
      meta: { requiresAuth: true }
    },
    {
      path: '/admin/newsEdit/:newsId',
      name: 'AdminNewsEdit',
      component: AdminNewsEdit,
      props: true,
      meta: { requiresAuth: true }
    },
    {
      path: '/admin/newsCreate',
      name: 'AdminNewsCreate',
      component: AdminNewsEdit,
      meta: { requiresAuth: true }
    },
    {
      path: '/admin/error',
      name: 'AdminError',
      component: AdminError,
    },
    {
      path: '/admin/*',
      name: 'AdminUndefined',
      component: AdminError
    },
    {
      path: '/',
      name: 'Top',
      component: Top,
      meta: { requiresAuth: true }
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/myPage',
      name: 'MyPage',
      component: MyPage,
      meta: { requiresAuth: true }
    },
    {
      path: '/messageList',
      name: 'MessageList',
      component: MessageList,
      props: true,
      meta: { requiresAuth: true }
    },
    {
      path: '/messageDetails/:messageId',
      name: 'MessageDetails',
      component: MessageDetails,
      props: true,
      meta: { requiresAuth: true }
    },
    {
      path: '/messageEdit/:messageId',
      name: 'MessageEdit',
      component: MessageEdit,
      props: true,
      meta: { requiresAuth: true }
    },
    {
      path: '/messageCreate',
      name: 'MessageCreate',
      component: MessageEdit,
      meta: { requiresAuth: true }
    },
    {
      path: '/messageCreate/:messageId',
      name: 'MessageQuote',
      component: MessageEdit,
      props: true,
      meta: { requiresAuth: true }
    },
    {
      path: '/commentView/:messageId/:studentId',
      name: 'CommentView',
      component: CommentView,
      props: true,
      meta: { requiresAuth: true }
    },
    {
      path: '/chatList',
      name: 'ChatList',
      component: ChatList,
      props: true,
      meta: { requiresAuth: true }
    },
    {
      path: '/chatMessageView/:tutorId/:studentId',
      name: 'ChatMessageView',
      component: ChatMessageView,
      props: true,
      meta: { requiresAuth: true }
    },
    {
      path: '/reportList',
      name: 'ReportList',
      component: ReportList,
      props: true,
      meta: { requiresAuth: true }
    },
    {
      path: '/reportDetails/:reportId',
      name: 'ReportDetails',
      component: ReportDetails,
      props: true,
      meta: { requiresAuth: true }
    },
    {
      path: '/reportEdit/:reportId',
      name: 'ReportEdit',
      component: ReportEdit,
      props: true,
      meta: { requiresAuth: true }
    },
    {
      path: '/reportCreate',
      name: 'ReportCreate',
      component: ReportEdit,
      meta: { requiresAuth: true }
    },
    {
      path: '/reportCreate/:reportId',
      name: 'ReportQuote',
      component: ReportEdit,
      props: true,
      meta: { requiresAuth: true }
    },
    {
      path: '/recordList',
      name: 'RecordList',
      component: RecordList,
      meta: { requiresAuth: true }
    },
    {
      path: '/recordView/:studentId',
      name: 'RecordView',
      component: RecordView,
      props: true,
      meta: { requiresAuth: true }
    },
    {
      path: '/enterLeaveList',
      name: 'EnterLeaveList',
      component: EnterLeaveList,
      meta: { requiresAuth: true }
    },
    {
      path: '/schoolEdit',
      name: 'SchoolEdit',
      component: SchoolEdit,
      meta: { requiresAuth: true }
    },
    {
      path: '/gradeAdvanceSetting',
      name: 'GradeAdvanceSetting',
      component: GradeAdvanceSetting,
      meta: { requiresAuth: true }
    },
    {
      path: '/userList',
      name: 'UserList',
      component: UserList,
      meta: { requiresAuth: true }
    },
    {
      path: '/studentList',
      name: 'StudentList',
      component: StudentList,
      meta: { requiresAuth: true }
    },
    {
      path: '/studentDetails/:studentId',
      name: 'StudentDetails',
      component: StudentDetails,
      props: true,
      meta: { requiresAuth: true }
    },
    {
      path: '/studentEdit/:studentId',
      name: 'StudentEdit',
      component: StudentEdit,
      props: true,
      meta: { requiresAuth: true }
    },
    {
      path: '/studentCreate',
      name: 'StudentCreate',
      component: StudentEdit,
      meta: { requiresAuth: true }
    },
    {
      path: '/studentBulkCreate',
      name: 'StudentBulkCreate',
      component: StudentBulkCreate,
      meta: { requiresAuth: true }
    },
    {
      path: '/recordControlList',
      name: 'RecordControlList',
      component: RecordControlList,
      meta: { requiresAuth: true }
    },
    {
      path: '/recordControlEdit/:gradesCollectionId/:semester',
      name: 'RecordControlEdit',
      component: RecordControlEdit,
      props: true,
      meta: { requiresAuth: true }
    },
    {
      path: '/singleSignOn/:token',
      name: 'SingleSignOn',
      component: SingleSignOn,
      props: true,
    },
    {
      path: '/singleSignOn/:token/:refreshToken',
      name: 'SingleSignOn:RefreshToken',
      component: SingleSignOn,
      props: true,
    },
    {
      path: '/schoolSingleSignOn/:token/:schoolId',
      name: 'SchoolSingleSignOn',
      component: SingleSignOn,
      props: true,
    },
    {
      path: '/manualList',
      name: 'ManualList',
      component: ManualList,
      meta: { requiresAuth: true }
    },

    {
      path: '/schedule',
      name: 'Schedule',
      component: Schedule,
      props: true,
      meta: { requiresAuth: true }
    },
    {
      path: '/schedule/edit/:calendarId',
      name: 'ScheduleEdit',
      component: ScheduleEdit,
      props: true,
      meta: { requiresAuth: true }
    },
    {
      path: '/schedule/reservableCount',
      name: 'ReservableCount',
      component: ReservableCount,
      props: true,
      meta: { requiresAuth: true }
    },
    {
      path: '/schedule/baseSchedule',
      name: 'BaseSchedule',
      component: BaseSchedule,
      props: true,
      meta: { requiresAuth: true }
    },

    {
      path: '/reservation',
      name: 'Reservation',
      component: Reservation,
      props: true,
      meta: { requiresAuth: true }
    },
    {
      path: '/reservation/calendar',
      name: 'ReservationCalendar',
      component: ReservationCalendar,
      props: true,
      meta: { requiresAuth: true }
    },

    {
      path: '/studentCalendar/:studentId',
      name: 'StudentCalendar',
      component: StudentCalendar,
      props: true,
      meta: { requiresAuth: true }
    },

    {
      path: '/studentCreditcard/:studentId',
      name: 'StudentCreditcard',
      component: StudentCreditcard,
      props: true,
      meta: { requiresAuth: true }
    },

    {
      path: '/tags',
      name: 'TagList',
      component: TagList,
      props: true,
      meta: { requiresAuth: true }
    },

    {
      path: '/bill/bills',
      name: 'BillList',
      component: BillList,
      meta: { requiresAuth: true }
    },
    {
      path: '/bill/bills/download',
      name: 'BillDownload',
      component: BillDownload,
      meta: { requiresAuth: true }
    },
    {
      path: '/bill/bills/create',
      name: 'BillCreate',
      component: BillEdit,
      meta: { requiresAuth: true }
    },
    {
      path: '/bill/bills/create/:billId',
      name: 'BillQuote',
      component: BillEdit,
      props: true,
      meta: { requiresAuth: true }
    },
    {
      path: '/bill/bills/:billId/edit',
      name: 'BillEdit',
      component: BillEdit,
      props: true,
      meta: { requiresAuth: true }
    },
    {
      path: '/bill/bills/:billId',
      name: 'BillDetail',
      component: BillDetail,
      props: true,
      meta: { requiresAuth: true }
    },

    {
      path: '/bill/periodic-bills',
      name: 'PeriodicBillList',
      component: PeriodicBillList,
      meta: { requiresAuth: true }
    },
    {
      path: '/bill/periodic-bills/create',
      name: 'PeriodicBillCreate',
      component: PeriodicBillEdit,
      meta: { requiresAuth: true }
    },
    {
      path: '/bill/periodic-bills/create/:periodicBillId',
      name: 'PeriodicBillQuote',
      component: PeriodicBillEdit,
      props: true,
      meta: { requiresAuth: true }
    },
    {
      path: '/bill/periodic-bills/:periodicBillId/edit',
      name: 'PeriodicBillEdit',
      component: PeriodicBillEdit,
      props: true,
      meta: { requiresAuth: true }
    },
    {
      path: '/bill/periodic-bills/:periodicBillId',
      name: 'PeriodicBillDetail',
      component: PeriodicBillDetail,
      props: true,
      meta: { requiresAuth: true }
    },

    {
      path: '/bill/bill-templates',
      name: 'BillTemplateList',
      component: BillTemplateList,
      meta: { requiresAuth: true }
    },
    {
      path: '/bill/bill-templates/create',
      name: 'BillTemplateCreate',
      component: BillTemplateEdit,
      meta: { requiresAuth: true }
    },
    {
      path: '/bill/bill-templates/:billTemplateId/edit',
      name: 'BillTemplateEdit',
      component: BillTemplateEdit,
      props: true,
      meta: { requiresAuth: true }
    },

    {
      path: '/bill/settings/bill',
      name: 'BillSetting',
      component: BillSetting,
      meta: { requiresAuth: true }
    },
    {
      path: '/bill/settings/creditcard',
      name: 'CreditcardSetting',
      component: CreditcardSetting,
      meta: { requiresAuth: true }
    },
    {
      path: '/bill/settings/bill-items',
      name: 'BillItemsSetting',
      component: BillItemsSetting,
      meta: { requiresAuth: true }
    },
    {
      path: '/checkout',
      name: 'Checkout',
      component: Checkout,
      meta: { requiresAuth: false }
    },

    {
      path: '/error',
      name: 'Error',
      component: Error,
    },
    {
      path: '/*',
      name: 'Undefined',
      component: Error
    },
  ],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  }
});
